import { useState } from 'react'

import Modal from '../modal'
import CrossIcon from '../svg/Cross'
import VideoPlayIcon from '../svg/VideoPlay'

interface VideoProps {
  videoLink: string
  fromYoutube?: boolean
}

interface Props extends VideoProps {
  thumbnailUrl: string
  imageStyles?: string
}

const Video = ({ videoLink, fromYoutube = false }: VideoProps) => {
  return fromYoutube ? (
    <iframe
      src={`${videoLink}?autoplay=1`}
      allow="accelerometer; autoplay; encrypted-media;
    gyroscope; picture-in-picture"
      allowFullScreen
      className="w-full max-w-3xl h-[250px] sm:h-[400px]"
    />
  ) : (
    <video controls className="w-full h-auto max-w-3xl" autoPlay>
      <source src={videoLink} type="video/mp4" />
    </video>
  )
}

const VideoModal = ({
  videoLink,
  thumbnailUrl,
  fromYoutube = false,
  imageStyles,
}: Props) => {
  const [isVideoModalVisible, setIsVideoModalVisible] = useState(false)

  const toggleVideoModal = () => {
    setIsVideoModalVisible((prev) => !prev)
  }
  return (
    <>
      <div className="relative" onClick={toggleVideoModal}>
        <img
          src={thumbnailUrl}
          alt=""
          className={`cursor-pointer w-full m-auto aspect-[1.312] rounded-2xl ${imageStyles}`}
        />

        <div
          className={`rounded-full bg-white w-12 h-12 absolute ${
            fromYoutube
              ? 'top-[calc(50%_-_22px)] left-[calc(50%_-_22px)]'
              : 'bottom-4 right-4'
          } z-10 flex items-center justify-center cursor-pointer`}
        >
          <VideoPlayIcon />
        </div>
      </div>
      <Modal show={isVideoModalVisible} mainContainerClassname="bg-transparent">
        <Video videoLink={videoLink} fromYoutube={fromYoutube} />

        <div className="absolute top-0 right-0" onClick={toggleVideoModal}>
          <CrossIcon />
        </div>
      </Modal>
    </>
  )
}

export default VideoModal
